import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { QueryFunction } from '@tanstack/react-query';
import { LoanType } from './types';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

interface GetLoanTypesResponse {
  success: boolean;
  loanTypes: LoanType[];
  nextCursor: string | null;
}

const getLoanTypes: QueryFunction<
  GetLoanTypesResponse,
  ['/loan-types']
> = async () => {
  if (isMockServices()) return await mock(_mockDocumentTypes);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<GetLoanTypesResponse>('/loan-types', {
    method: 'GET',
    paginate: true,
    accumulateKey: 'loanTypes',
    nextCursorKey: 'nextCursor',
    limit: 100,
  });

  return {
    success: true,
    loanTypes: response.data?.loanTypes ?? [],
    nextCursor: null,
  };
};

export default getLoanTypes;

const _mockDocumentTypes = {
  success: true,
  loanTypes: [{ id: 'test-id', name: 'razvan' }],
  nextCursor: null,
};
